import { IExpressionEvaluator, IHasExpressionMetadata } from "../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";
import { WhenExpression } from "../../Models/WhenExpression";

export class WhenExpressionEvaluator implements IExpressionEvaluator<WhenExpression>, IHasExpressionMetadata {
  get type(): string {
    return "When";
  }

  private static _expressionPropertyNames: string[] = ["Condition", "Then", "Else"];

  get expressionProperties(): string[] {
    return WhenExpressionEvaluator._expressionPropertyNames;
  }

  evaluate(expression: WhenExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const conditionResult = expression.Condition ? context.Evaluator.evaluate(expression.Condition, context) : true;

    if (conditionResult instanceof Promise) {
      return conditionResult.then((resolvedCondition) => {
        if (resolvedCondition) {
          return context.Evaluator.evaluate(expression.Then, context);
        }
        return expression.Else ? context.Evaluator.evaluate(expression.Else, context) : undefined;
      });
    }

    if (conditionResult) {
      return context.Evaluator.evaluate(expression.Then, context);
    }
    return expression.Else ? context.Evaluator.evaluate(expression.Else, context) : undefined;
  }
}
